import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import cn from 'classnames';
import { GetBemBlocksWith } from '@ebsco-ui/ebsco-ui';

import { ContributorDto, DelimitedList, SearchOption } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { Route } from '@app/constants';

const maxRecordsToDisplay = 3;

export interface ContributorsListProps {
  cnBemModalOrPlacement: GetBemBlocksWith;
  shouldDisplayNameAsText: boolean;
  list?: ContributorDto[];
}

export const ContributorsList: FC<ContributorsListProps> = ({
  cnBemModalOrPlacement,
  list = [],
  shouldDisplayNameAsText,
}) => {
  const queryParams = useQueryParams();
  const { setInstanceIdScrollTo } = useSearchContext();

  if (isEmpty(list)) {
    return null;
  }

  return (
    <DelimitedList
      limit={maxRecordsToDisplay}
      delimiter=", "
      items={list.map(({ name, contributorTypeName, contributorTypeText }) => (
        <Fragment key={name}>
          {!shouldDisplayNameAsText ? (
            <Link
              to={generateRouteParams({
                pathname: Route.search,
                query: {
                  ...queryParams,
                  pageNumber: 1,
                  option: SearchOption.author,
                  query: name,
                },
              })}
              className={cn('underlinedLink', cnBemModalOrPlacement('__link'))}
              onClick={() => setInstanceIdScrollTo(null)}
            >
              {name}
            </Link>
          ) : (
            name
          )}
          {(contributorTypeName || contributorTypeText) &&
            `, ${contributorTypeName || contributorTypeText}`}
        </Fragment>
      ))}
    />
  );
};
